import { Status } from "utilities/enumerations/statuses";
import { Map } from "utilities/types/map";
import { TranslatedCopy } from "utilities/interfaces/culture-resources";

// -----------------------------------------------------------------------------------------
// #region Enum
// -----------------------------------------------------------------------------------------
enum EvaluationStatus {
    NotStarted = 0,
    Complete = 1,
    Exempt = 2,
}

// #endregion Enum

// -------------------------------------------------------------------------------------------------
// #region Maps
// -------------------------------------------------------------------------------------------------
const EvaluationStatusDisplayNames: Map<EvaluationStatus, TranslatedCopy> = {
    [EvaluationStatus.NotStarted]: "notStarted",
    [EvaluationStatus.Complete]: "complete",
    [EvaluationStatus.Exempt]: "exempt",
};


const EvaluationStatusMap: Map<EvaluationStatus, Status> = {
    [EvaluationStatus.NotStarted]: Status.Default,
    [EvaluationStatus.Complete]: Status.Success,
    [EvaluationStatus.Exempt]: Status.Warning,
};



// #endregion Maps

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export {
    EvaluationStatus,
    EvaluationStatusMap,
    EvaluationStatusDisplayNames
};

// #endregion Exports
